import { createSlice } from "@reduxjs/toolkit";
import { getCaptions, getVisibleCaptions } from "./functions";
import ReducerRegistry from "../base/redux/ReducerRegistry";
const initialState = {
    enabledSaveCaption: false,
    enabled: false,
    captions: [],
    visibleCaptions: [],
    streamStatus: "stopped",
    languageTranscription: localStorage.getItem("languageTranscription") || "vi",
    timeWait: 0,
    pushLayoutUser: false,
    isFirstSaveEnabled: false,
    isOwnerCaption: false
};
export const addCaption = (caption) => (dispatch, getState) => {
    const captions = getCaptions(getState());
    const visibleCaptions = getVisibleCaptions(getState());
    // console.log("====> sonph21 visibleCaptions 1", visibleCaptions, captions);
    const newCaptions = [...captions, caption];
    dispatch(setCaptions(newCaptions));
    let newVisibleCaptions;
    const _caption = { ...caption };
    _caption.timeout = setTimeout(() => {
        dispatch(removeVisibleCaption(_caption));
    }, 5000);
    const prevCaption = visibleCaptions.find((vc) => vc.text_id === _caption.text_id);
    if (prevCaption) {
        clearTimeout(prevCaption.timeout);
        newVisibleCaptions = visibleCaptions.map((vc) => vc.text_id === _caption.text_id ? _caption : vc);
    }
    else {
        newVisibleCaptions = [...visibleCaptions, _caption];
    }
    if (newVisibleCaptions.length === 5) {
        newVisibleCaptions.shift();
    }
    dispatch(setVisibleCaptions(newVisibleCaptions));
};
export const removeVisibleCaption = (caption) => (dispatch, getState) => {
    const visibleCaptions = getVisibleCaptions(getState());
    let newVisibleCaptions = visibleCaptions?.filter((c) => c.text_id !== caption.text_id);
    dispatch(setVisibleCaptions(newVisibleCaptions));
};
const liveCaptionSlice = createSlice({
    name: 'features/live-caption',
    initialState,
    reducers: {
        disableSaveLiveCaption: (state) => {
            state.enabledSaveCaption = false;
        },
        enableSaveLiveCaption: (state) => {
            state.enabledSaveCaption = true;
        },
        disableLiveCaption: (state) => {
            state.enabled = false;
        },
        enableLiveCaption: (state) => {
            state.enabled = true;
        },
        setCaptions: (state, action) => {
            state.captions = action.payload;
        },
        setStreamStatus: (state, action) => {
            state.streamStatus = action.payload;
        },
        setLanguageTranscription: (state, action) => {
            state.languageTranscription = action.payload;
        },
        setVisibleCaptions: (state, action) => {
            state.visibleCaptions = action.payload;
        },
        setTimeWait: (state, action) => {
            state.timeWait = action.payload;
        },
        setEnableSaveLiveCaption: (state, action) => {
            state.enabledSaveCaption = action.payload;
        },
        setPushLayoutUser: (state, action) => {
            state.pushLayoutUser = action.payload;
        },
        setIsFirstSaveEnabled: (state, action) => {
            state.isFirstSaveEnabled = action.payload;
        },
        setIsOwnerCaption: (state, action) => {
            state.isOwnerCaption = action.payload;
        }
    },
});
ReducerRegistry.register('features/live-caption', liveCaptionSlice.reducer);
export const { disableSaveLiveCaption, enableSaveLiveCaption, disableLiveCaption, enableLiveCaption, setCaptions, setVisibleCaptions, setStreamStatus, setLanguageTranscription, setTimeWait, setEnableSaveLiveCaption, setPushLayoutUser, setIsFirstSaveEnabled, setIsOwnerCaption } = liveCaptionSlice.actions;
export default liveCaptionSlice.reducer;
